// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"5a372e5b","444":"a46d002d","453":"64474f44"}[chunkId] + ".chunk.js";
};